<h1 mat-dialog-title>
    <span translate="admin.comptabilite.planComptable.compteComptable.usage.title"></span>
    <span [mat-dialog-close]="true"><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <list-view [liste]="listeUsage"></list-view>
</div>